import React, {useState, useEffect} from 'react';
import {useLazyQuery} from '@apollo/client';

import {LOOKUP_SESSION_WITH_SESSION_RECORDING} from '../../queries/GraphQLQueries';
import HoverableZoomMeetingRecordingChip from '../common/HoverableZoomMeetingRecordingChip';

const RecordingCell = ({sessionId}) => {
    const [isZoomRecordingChipHoveredOver, setIsZoomRecordingChipHoveredOver] = useState(false);
    const [lookupSession, {loading: isLoadingRecording, data}] = useLazyQuery(LOOKUP_SESSION_WITH_SESSION_RECORDING, {fetchPolicy: 'network-only'});

    useEffect(() => {
        if (isZoomRecordingChipHoveredOver) {
            lookupSession({variables: {sessionId}});
        }
    }, [isZoomRecordingChipHoveredOver, sessionId]);

    return (
        <HoverableZoomMeetingRecordingChip
            setIsZoomRecordingChipHoveredOver={setIsZoomRecordingChipHoveredOver}
            isZoomRecordingChipHoveredOver={isZoomRecordingChipHoveredOver}
            session={data?.sessionInfo}
            isDataLoading={isZoomRecordingChipHoveredOver && isLoadingRecording}/>
    );
};

export default RecordingCell;